import EntityUrl from '../EntityUrl';

class GroupUrl extends EntityUrl {
    getRelativePath(id: number): string {
        return `/groups/${id}`;
    }
}

export default GroupUrl;